/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckChecklistItemRequirement } from './PaxCheckChecklistItemRequirement';
import {
    PaxCheckChecklistItemRequirementFromJSON,
    PaxCheckChecklistItemRequirementFromJSONTyped,
    PaxCheckChecklistItemRequirementToJSON,
    PaxCheckChecklistItemRequirementToJSONTyped,
} from './PaxCheckChecklistItemRequirement';

/**
 * Composed checklist item requirement: And([ChecklistItemRequirement])
 * @export
 * @interface PaxCheckComposedAnd
 */
export interface PaxCheckComposedAnd {
    /**
     * Requirement represented as text
     * @type {string}
     * @memberof PaxCheckComposedAnd
     */
    asText: string;
    /**
     * Embedded requirements as a list (... and ... and ...)
     * @type {Array<PaxCheckChecklistItemRequirement>}
     * @memberof PaxCheckComposedAnd
     */
    requirements: Array<PaxCheckChecklistItemRequirement>;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckComposedAnd
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckComposedAnd interface.
 */
export function instanceOfPaxCheckComposedAnd(value: object): value is PaxCheckComposedAnd {
    if (!('asText' in value) || value['asText'] === undefined) return false;
    if (!('requirements' in value) || value['requirements'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckComposedAndFromJSON(json: any): PaxCheckComposedAnd {
    return PaxCheckComposedAndFromJSONTyped(json, false);
}

export function PaxCheckComposedAndFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckComposedAnd {
    if (json == null) {
        return json;
    }
    return {
        
        'asText': json['as_text'],
        'requirements': ((json['requirements'] as Array<any>).map(PaxCheckChecklistItemRequirementFromJSON)),
        'type': json['type'],
    };
}

export function PaxCheckComposedAndToJSON(json: any): PaxCheckComposedAnd {
    return PaxCheckComposedAndToJSONTyped(json, false);
}

export function PaxCheckComposedAndToJSONTyped(value?: PaxCheckComposedAnd | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'as_text': value['asText'],
        'requirements': ((value['requirements'] as Array<any>).map(PaxCheckChecklistItemRequirementToJSON)),
        'type': value['type'],
    };
}

